import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { CITIES, scrollToSection } from "./data";

const ServiceArea = () => (
  <section
    id="service-area"
    data-testid="service-area-section"
    className="grain relative overflow-hidden bg-navy-dark py-24 sm:py-32"
  >
    <div className="bg-grid-gold absolute inset-0" aria-hidden="true" />
    <div className="absolute -left-32 bottom-0 h-96 w-96 rounded-full bg-gold/10 blur-[120px]" aria-hidden="true" />
    <img
      src="/assets/logo_gold.webp"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-28 -right-28 w-[520px] max-w-none opacity-[0.05]"
    />

    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead num="05" eyebrow="Service Area" title="Proudly Serving Northern Nevada" dark center testid="service-area-head" />

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {CITIES.map((c, i) => (
          <Reveal key={c.slug} delay={i * 0.09}>
            <button
              data-testid={`city-card-${c.slug}`}
              onClick={() => scrollToSection("#contact")}
              className="group relative h-full w-full overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04] p-8 text-left backdrop-blur-sm transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1.5 hover:border-gold/40 hover:bg-white/[0.07]"
            >
              <span
                aria-hidden="true"
                className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-gold/10 blur-2xl transition-opacity duration-300 group-hover:opacity-100"
              />
              <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-gold/10 text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy">
                <MapPin size={22} strokeWidth={1.8} />
              </span>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-wide text-white">{c.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/60">{c.desc}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-[11px] font-extrabold tracking-[0.2em] text-gold/80 transition-colors group-hover:text-gold">
                GET SERVICE IN {c.name}
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </button>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 text-center text-sm text-white/50">
          Just outside these areas?{" "}
          <a href="tel:+17757458288" data-testid="service-area-call-link" className="font-semibold text-gold transition-colors hover:text-gold-light">
            Call us
          </a>{" "}
          — we take on projects throughout Northern Nevada.
        </p>
      </Reveal>
    </div>
  </section>
);

export default ServiceArea;
